import { useGetSubscriptionTypeForProduct } from "./useGetSubscriptionTypeForProduct";
import { useIsUserSubscribed } from "./useIsUserSubscribed";
import { SINGLE_ISIN_PRODUCT_ID } from "../constants/REPORTS";

export const useIsSingleIsinReportAvailable = (userId) => {
    const singleIsinSubscriptionId = useGetSubscriptionTypeForProduct(SINGLE_ISIN_PRODUCT_ID);
    const hasUserCurrentSubscription = useIsUserSubscribed(userId, singleIsinSubscriptionId);
    return hasUserCurrentSubscription?.isSubscribed && hasUserCurrentSubscription?.isVisible;
}